// extracted by mini-css-extract-plugin
module.exports = {"tickIcon":"styles_tickIcon__3SU25","headerIcon":"styles_headerIcon__1iPr4","underline":"styles_underline__2E3YU"};